import { render, staticRenderFns } from "./ResultEx.vue?vue&type=template&id=09ab47e7&scoped=true&"
import script from "./ResultEx.vue?vue&type=script&lang=js&"
export * from "./ResultEx.vue?vue&type=script&lang=js&"
import style0 from "./ResultEx.vue?vue&type=style&index=0&id=09ab47e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ab47e7",
  null
  
)

export default component.exports